// extracted by mini-css-extract-plugin
export var textInput = "_ka-0";